import { TableCell } from '@mui/material';
import type React from 'react';
import { DEFAULT_USER_NAME } from '../../../versions/constants.js';

export type MemberCellProps = {
  readonly value?: {
    id?: string;
    fullName?: string;
  };
};

const MemberCell: React.FC<MemberCellProps> = ({ value }: MemberCellProps) => {
  const name = value?.fullName ?? DEFAULT_USER_NAME;
  return <TableCell title={name}>{name}</TableCell>;
};

export default MemberCell;
